// extracted by css-extract-rspack-plugin
export default {"timestamp":"TimelineEvent-module__timestamp__fgWAM"};